/*
 * @Author: LiuLiXue QQ:136890965
 * @Date: 2017-12-22 14:34:18
 * @Last Modified by: aLeng
 * @Last Modified time: 2018-06-20 09:43:43
 */
// 编辑和增加弹框
<template>
  <el-dialog class="dialog-wrap"
  :visible.sync="isVisible"
  :before-close="handleClose"
  >
    <div class="title" slot='title' v-text="title"></div>
    <div class="border"></div>
    <el-form :model="form" :rules="rules" ref="form" :label-width="formLabelWidth" label-position="left">
      <el-form-item prop="loginName">
        <span class="label" slot="label">
          账号
        </span>
        <el-input v-model.trim="form.loginName" :maxlength="20"  placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item prop="fullName">
        <span class="label" slot="label">
          姓名
        </span>
        <el-input v-model.trim="form.fullName" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item prop='mobile'>
        <span class="label" slot="label">
          手机号
        </span>
        <el-input v-model.number="form.mobile" placeholder="请输入手机号" :maxlength="maxlength"></el-input>
      </el-form-item>
      <el-form-item size="medium" prop="roleId">
        <span class="label" slot="label">
          角色
        </span>
        <el-select class="el-select" v-model="form.roleId" placeholder="请选择用户角色">
          <el-option v-for="item in listRole"
            :key="item.roleId"
            :label="item.roleName"
            :value="item.roleId"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_cancel">取 消</el-button>
      <el-button class="sure" @click="_sure('form')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { validateTel } from "@/utils/validate";
export default {
  name: "editBox",
  props: {
    title: {
      type: String,
      default: "编辑用户"
    },
    visible: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    listRole: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    isVisible() {
      return this.visible;
    }
  },
  watch: {
    userInfo(newValue) {
      if (newValue.loginName) {
        this.form["loginName"] = newValue.loginName;
        this.form["fullName"] = newValue.fullname;
        this.form["mobile"] = newValue.mobile;
        this.form["userId"] = Number(newValue.userId);
        this.form["roleId"] = newValue.roleId;
      } else {
        this.form["loginName"] = "";
        this.form["fullName"] = "";
        this.form["mobile"] = "";
        this.form["roleId"] = "";
      }
    }
  },
  data() {
    const valiPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else if (!validateTel(value)) {
        return callback(new Error("请输入正确手机号"));
      } else {
        callback();
      }
    };
    return {
      dialogTableVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "80px",
      maxlength: 11,
      roleId: "",
      form: {
        loginName: "",
        fullName: "",
        mobile: "",
        roleId: ""
      },
      rules: {
        loginName: [{ required: true, message: "请输入账号", trigger: "blur" }],
        fullName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {min: 1,max: 20,message:'长度在1到20个字符', trigger:'blur'}
        ],
        mobile: [{ required: true, validator: valiPhone, trigger: ",blur" }],
        roleId: [{ required: true, message: "请选择角色", trigger: "blur" }]
      }
    };
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$emit('cancel')

        })
        .catch(() => {
          this.$emit("noClosed");
        });
    },
    _cancel() {
      this.$emit("cancel");
    },
    _sure(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.form["mobile"] = String(this.form.mobile);
          this.form["roleId"] = Number(this.form.roleId);
          this.$emit("sure", this.form);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$input-width: 500px;
$border-color: #e2e2e2;
%_font {
  font-size: 14px;
  color: #323232;
}
.dialog-wrap {
  .title {
    @extend %_font;
  }
  .border {
    margin: -30px -20px 20px;
    border-bottom: 1px solid $border-color;
  }
  .label {
    @extend %_font;
  }
  .dialog-footer {
    margin: 0 -15px -15px;
    padding: 10px 15px;
    border-top: 1px solid $border-color;
    background-color: #f7f7f7;
    .el-button.sure{
      background-color: #31cf86;
      font-size: 14px;
      color: #fff;
    }
  }
  .el-dialog--center {
    .el-dialog__body {
      text-align: center;
    }
  }
  .el-dialog {
    width: 500px;
  }
  .el-input {
    width: $input-width;
  }
  .el-select {
    width: $input-width;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/permissions/EditBox.vue